export default __webpack_public_path__ + "static/media/pizza.4e16fc92.webp";